import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { IInviteTrainerToCourseRequest } from '@treneo/models';
import { ResultHelpers } from '@treneo/models';

import { coursesApi } from '../api';
import { COURSE_TRAINER_INVITATIONS_QUERY_KEY } from '../queries/course-trainer-invitations-query';

export const useInviteTrainerToCourseMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: IInviteTrainerToCourseRequest) => {
      const result = await coursesApi.inviteTrainerToCourse({
        courseId: request.courseId,
        email: request.email,
        origin: request.origin
      });
      return ResultHelpers.unwrapWith(
        result,
        data => ({ courseId: request.courseId, ...data }),
        'Invite trainer to course failed'
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [COURSE_TRAINER_INVITATIONS_QUERY_KEY, variables.courseId]
      });
    }
  });
};
